import React from "react";

export const IconCompletedStep = ({ handleClick = false }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <circle cx="16" cy="16" r="16" fill="#F2F2FB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7056 11.9534L14.0244 20.7319L10.293 17.0005L11.0001 16.2934L13.9757 19.269L20.953 11.2949L21.7056 11.9534Z"
      fill="#4700D1"
    />
  </svg>
);

export default IconCompletedStep;
